import { FC, useEffect, useState } from 'react';
import { CloseButton } from '../../../../../lib/components/Buttons/CloseButton';
import { Tag } from '../../../../../lib/model/Tag';
import { TagTypeWithColor } from './Tags/tag_type';
import { Card, Input, Select, message } from 'antd';
import { AddButton } from '../../../../../lib/components/Buttons/AddButton';
import { SelectedTagsForIa } from '../../../clients/client_contracts/components/SelectedTagsForIa';
import { validate_email } from '../../../../../lib/utils/validate_email';

const BASE_URL = process.env.REACT_APP_CLIENT_CONTRACT_MANAGEMENT_API;

interface IProps {
	selected_contents: Tag[];
	tag_type: TagTypeWithColor;
	on_change: (tags: Tag[]) => void;
	close: () => void;
}

export const SelectTagsIaUser: FC<IProps> = ({ on_change, tag_type, selected_contents, close }) => {
	const [selected_tags, set_selected_tags] = useState(selected_contents);
	const [is_loading, set_is_loading] = useState(false);
	const [email, set_email] = useState('');

	function insert_tag_with_color() {
		if (!validate_email(email)) {
			message.error('E-mail inválido. Por favor, insira um e-mail no formato correto.');
			return;
		}
		const tag: Tag = {
			id: `forum-ia|${email}`,
			title: `Forum IA: ${email}`,
		};
		set_selected_tags([...selected_tags, tag]);
		//message.success('Adicionado com sucesso.');
		set_email('');
	}

	function remove_tag(tag: Tag) {
		const new_contents = selected_tags.filter((content) => content !== tag);
		set_selected_tags(new_contents);
	}

	function select_tags() {
		on_change(selected_tags);
		close();
	}

	const get_tag_type_title = (tag: Tag): string => {
		if (tag?.id?.includes('forum-ia')) {
			return `${tag.title}`;
		}
		if (tag?.id?.includes('book_')) {
			return `Livro Avulso: ${tag.title}`;
		}
		if (tag?.id?.includes('book')) {
			return tag?.id?.includes('legislacao-comentada') ? `${tag.title}` : `Livros: ${tag.title}`;
		}
		if (tag?.id?.includes('video')) {
			return `Vídeos: ${tag.title}`;
		}

		return `${tag.title}`;
	};

	useEffect(() => {
		on_change(selected_tags);
	}, [selected_tags]);

	return (
		<section className='flex flex-col w-full'>
			<div className='flex flex-row justify-between'>
				<Card
					style={{ background: '#fff', marginTop: 1, width: '100%' }}
					bodyStyle={{ width: '100%' }}
					className='flex flex-row rounded border border-gray-100 p-4 bg-gray-50 flex-wrap max-w-lg'
				>
					<div className='grid grid-cols-2'>
						<div className='col-span-2 block mb-3 pl-2'>
							<label>
								<span className='text-xs mr-1'>Email</span>
								<span className='font-semibold text-red-500'>*</span>
							</label>
							<Input value={email} onChange={(event) => set_email(event.target.value)} />
						</div>
						<div className='col-span-2 block mb-3'>
							<AddButton onClick={insert_tag_with_color} />
						</div>
					</div>
				</Card>
			</div>

			{selected_tags.length !== 0 && !is_loading && (
				<SelectedTagsForIa {...{ items: selected_tags, remove_tag, get_tag_type_title }} />
			)}
			<div className='flex justify-end mt-8'>
				<CloseButton disabled={selected_tags.length === 0} onClick={select_tags} />
			</div>
		</section>
	);
};
